import { render, staticRenderFns } from "./CompetencesFilter.vue?vue&type=template&id=2c383f78&"
import script from "./CompetencesFilter.vue?vue&type=script&lang=js&"
export * from "./CompetencesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports